// import i18n from "@/i18n";
import moment from "moment";
import { message } from "antd";
const Utils = {
  downloadFile: (obj, name) => {
    message.loading("downloading", 0);
    let url = obj.url;
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        message.destroy();
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = name;
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        message.destroy();
        message.error("Download failed.");
      });
  },
  getUpdateTime: param => {
    const duration = parseInt(new Date().getTime() / 1000 - param);
    if (duration <= 60) {
      return { i18Key: "justNow" };
    } else if (duration < 60 * 2) {
      return { i18Key: "MAgo", num: 1 };
    } else if (duration < 60 * 60) {
      return { i18Key: "MAgo", num: parseInt(duration / 60) };
    } else if (duration < 60 * 60 * 2) {
      return { i18Key: "HAgo", num: 1 };
    } else if (duration <= 60 * 60 * 24) {
      return { i18Key: "HAgo", num: parseInt(duration / 60 / 60) };
    } else {
      return { i18Key: "DAgo", num: 1 };
    }
  },
  getSize: param => {
    if (param <= 1024 * 1024) {
      return (param / 1024).toFixed(0) + "KB";
    } else if (param <= 1024 * 1024 * 1024) {
      return (param / 1024 / 1024).toFixed(2) + "MB";
    }
  },
  getSeconds: obj => {
    if (moment(obj.replace(".", ":"), "mm:ss:SS").isValid()) {
      return moment.duration(moment(obj.replace(".", ":"), "mm:ss:SS").valueOf() - moment("00:00:00", "mm:ss:SS").valueOf()).as("seconds");
    } else {
      return 0;
    }
  },
};
export default Utils;
